module.exports = __webpack_public_path__ + "static/media/editActive.5c60197a.svg";